import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { Announcements } from "../../Announcement/Announcement";
import { General } from "./General/General";
import { Circular } from "./Circular/Circular";
import { Icon } from "@iconify/react";

export const Announcement = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const id = query?.get("id");

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/announcements?activeTab=tender`, {
        replace: true,
      });
    }
  }, [navigate, query]);

  const items = [
    {
      label: "Tender",
      key: "tender",
      children: <Announcements/>
    },
    {
      label: "General",
      key: "general",
      children: <General/>
    },
    {
      label: "Circular",
      key: "circular",
      children: <Circular/>
    }
  ];

  const handleProductManagement=(activeTab:any)=>{
    if(activeTab === 'tender') {
      return (<Button
        type="ghost"
        onClick={() => navigate("/dedicated/magp/announcements/add")}
        icon={<Icon icon={"lucide:plus"} />}
      >
        Add New Tender
      </Button>
      )
    } else if(activeTab === 'general') {
        return (<Button
        onClick={() => {
          navigate("/dedicated/magp/announcements/general/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
      >
        Add New General
      </Button>
      )
    } else if(activeTab === 'circular') {
      return (<Button
      onClick={() => {
        navigate("/dedicated/magp/announcements/circular/add");
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
      Add New Circular
    </Button>
    )
  }
  }

  return (
    <ContentWrapper title={"Announcements"}
    actionItems={handleProductManagement(query.get('activeTab'))}>
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
